import React from "react";
import "./ListHeading.scss";
import { IoIosArrowForward } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ListHeading = ({
  dataTableHeadingText,
  dataTableHeadingIcon,
  dataTablePageLink,
  dataTableHeadingReactIcon
}) => {
  let title = [];
  let icons = [];
  let links = [];

  dataTableHeadingText instanceof Array
    ? (title = [...title, ...dataTableHeadingText])
    : title.push(dataTableHeadingText);

  dataTableHeadingIcon instanceof Array
    ? (icons = [...icons, ...dataTableHeadingIcon])
    : icons.push(dataTableHeadingIcon);

  dataTablePageLink instanceof Array
    ? (links = [...links, ...dataTablePageLink])
    : links.push(dataTablePageLink);

  return (
    <div className="d-flex flex-row justify-content-start align-items-center">
      {title.map((titles, index) => (
        <div className="d-flex align-items-center text-decoration-none">
          {dataTableHeadingReactIcon && (
            <div className="me-3 main-heading-image">{dataTableHeadingReactIcon}</div>
          )}
          {dataTableHeadingIcon && icons[index] && (
            <img
              src={icons[index]}
              alt="icon"
              id="center-blueShadow"
              className="me-3 main-heading-image"
            />
          )}
          <h2 className="main-heading pe-2">{titles}</h2>
        </div>
      ))}
    </div>
  );
};

export default ListHeading;
